<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card class="universal-vcard">
      <div class="universal-vdialog-title">
        <span>{{ $t('components.knowledge_management.insert_category.' + (isEditMode ? 'edit_category' : 'add_category')) }}</span>
      </div>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="categoryName"
            class="universal-vdialog-textfield"
            :rules="nameRules"
            :label="$t('components.knowledge_management.insert_category.category_name')"
            required
            clearable
          ></v-text-field>
        </v-form>
        <div class="vdialog-buttons-wrapper wrapper-three-buttons">
        <div class="universal-vdialog-button vbutton-secondary" text @click="close">{{ $t('components.knowledge_management.insert_category.cancel') }}</div>
        <div class="universal-vdialog-button vbutton-primary" text @click="saveCategory" :disabled="!valid">{{ $t('components.knowledge_management.insert_category.save') }}</div>
    </div>
    </v-card>
  </v-dialog>

</template>

<script>
import { createCategory, updateCategory } from '../../apiCallers/promise_handler_db/knowledgeManagement';

export default {
  name: 'CategoryDialog',

  data() {
    return {
      dialog: false,
      valid: false,
      categoryName: '',
      isEditMode: false,
      categoryId: null,
      nameRules: [
        v => !!v || this.$t('components.knowledge_management.insert_category.validation.required'),
        v => (v && v.length <= 40) || this.$t('components.knowledge_management.insert_category.validation.max_length')
      ]
    };
  },
  methods: {
    open(selcted_category = null) {
      if(selcted_category)
    {
      this.isEditMode = true;
      this.categoryName = selcted_category.name;
      this.categoryId = selcted_category.id;
    }
    else{
      this.isEditMode = false;
    }
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    resetFormData() {
      this.categoryName = '';
      this.categoryId = null;
      this.$refs.form.resetValidation();
    },
    async saveCategory() {
      if (this.$refs.form.validate()) {
        try {
          if (this.isEditMode) {
            await updateCategory(this.categoryId, this.categoryName);
          } else {
            await createCategory(this.categoryName);
            this.categoryName = ""

          }
          this.$emit('update-list');
          this.close();
        } catch (error) {
          console.error("There was an error saving the category:", error);
        }
      }
    }
  }
};
</script>

